import * as React from "react";

const ShoppingCart: React.FC = () => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 .5)" fill="#002554" fillRule="evenodd"><circle cx="7.5" cy="19.5" r="1.5" /><circle cx="18" cy="19.5" r="1.5" /><path d="M21 3.75H4.365L3.75.6A.75.75 0 0 0 3 0H0v1.5h2.385L5.25 15.9a.75.75 0 0 0 .75.6h13.5V15H6.615L6 12h13.5a.75.75 0 0 0 .75-.585l1.5-6.75A.75.75 0 0 0 21 3.75Zm-2.1 6.75H5.715l-1.05-5.25h15.398L18.9 10.5Z" fillRule="nonzero" /></g></svg>
    );
};

export default React.memo(ShoppingCart);
